

































import { FinanceType, LoadingStatusType, QRPaymentType, TransactionType, TypeComponentNoti } from "@/enums/enums";
import { MerchantId } from "@/helper/authenticationHelper";
import { GetURLName } from "@/helper/documentHelper";
import { IsKeyBoardEN, ValidateEmailFormatError } from "@/helper/shareHelper";
import {
  BeamRequestModel,
  DataBeamPaymentModel,
  DataPaySolutionPaymentModel,
  PaySolutionRequestModel,
} from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");
const StoreMerchant = namespace("Merchant");
const StoreLoading = namespace("Loading");
const StoreAlert = namespace("Alert");

@Component
export default class ModalInfoToConfirmPaymentPaySolutions extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: TransactionType.None }) transactionType!: TransactionType;
  @Prop({ default: FinanceType.None }) financeType!: FinanceType;
  @Prop({ default: "" }) transactionNumber!: string;

  private showModal = true;
  private isShowFormSubmit = false;
  private postBackUrl = `${process.env.VUE_APP_PeakDocument}${GetURLName(
    this.transactionType,
    this.financeType
  )}?emi=${MerchantId().PeakEncryption()}&eti=${this.transactionId.PeakEncryption()}&etti=${this.transactionType.PeakEncryption()}&efti=${this.financeType.PeakEncryption()}`;
  private email = {
    value: "",
    validateError: false,
  };
  private paymentLink = "";
  private isDisable = true;

  @StorePayment.Getter
  private getBeamPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getBeamPaymentModel!: DataBeamPaymentModel;

  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;

  @StorePayment.Action
  private DoGetBeamPayment!: (input: BeamRequestModel) => void;

  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;

  created() {
    this.GetQRPaymentSetting();
  }

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  @Watch("getBeamPaymentLoadingStatus")
  getBeamPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getBeamPaymentModel && this.getBeamPaymentModel.paymentLink) {
        this.paymentLink = this.getBeamPaymentModel.paymentLink;
        this.isDisable = false;
      } else {
        this.isDisable = true;
      }
    }
  }

  @Watch("getMerchantQRPaymentSettingLoadingStatus")
  getMerchantQRPaymentSettingLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success && this.getMerchantQRPaymentModel.qrPaymentTypeId == QRPaymentType.Beam) {
      this.GetBeamPayment();
    }
  }

  public GetBeamPayment() {
    const input: BeamRequestModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      onlineViewUrl: this.postBackUrl,
    };
    this.DoGetBeamPayment(input);
  }

  public RedirectToBeam() {
    window.open(this.paymentLink, "_blank");
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
